import { Box, Heading } from '@chakra-ui/layout';

const AccountDeleteTabComponent = ({ user }) => {
  return (
    <Box mx={25}>
      <Heading color='teal'>Delete your account</Heading>
    </Box>
  );
};

export default AccountDeleteTabComponent;
